<template>
  <el-date-picker
    v-model="_value"
    class="my-select"
    :clearable="false"
    inline
    :type="type"
    :value-format="format"
    range-separator="-"
    :start-placeholder="$t('components.global.startDate')"
    :end-placeholder="$t('components.global.endDate')"
    :style="_style"
    v-bind="$attrs"
    @change="change"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: 'DateRangePickerItem',
  props: {
    value: {
      type: Array
    },
    width: {
      type: String,
      default: '280px'
    },
    height: {
      type: String,
      default: '40px'
    },
    styleSheet: {
      type: Object,
      default: function() {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    type: {
      type: String,
      default: 'daterange'
    },
    
  },
  data() {
    return {}
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    _style() {
      return Object.assign(
        {},
        {
          width: this.width,
          height: this.height,
          'line-height': this.height
        },
        this.styleSheet
      )
    }
  },
  methods: {
    change(val) {
      this._value = val
    }
  }
}
</script>
<style lang='scss' scoped>
.my-select {
	::v-deep.el-date-editor {
		width: 280px;
		height: 32px;
		line-height: 32px;
		border: 1px solid #dfe3e5;
		border-radius: 16px;
		.el-range__close-icon {
			display: none;
		}
		.el-range__icon {
			display: none;
		}
		.el-range-separator {
			width: 32px;
			height: 32px;
			line-height: 32px !important;
			font-family: PingFangSC-Regular;
			font-size: 14px;
			color: rgba(0, 0, 0, 0.65);
			letter-spacing: 0;
		}
		.el-range-input {
			flex: 1;
		}
	}

	.el-range-editor.el-input__inner {
		height: 32px;
		line-height: 32px;
		justify-content: center;
	}
}
</style>
